import { useMemo } from 'react'
import {
  VersionReportVersionEntity,
  VersionReportVersionPageEntity,
} from '../../../../domain/entity/version-report/VersionReportVersionEntity'
import { useVersionReportVersionRepository } from '../../../../services/adaptors/versionReportVersionRepositoryAdaptor'
import { isAiAvailable } from '../../../../lib/functions/ai'

export const useEvaluate = (
  currentVersion: VersionReportVersionEntity | undefined,
  currentPage: VersionReportVersionPageEntity | undefined
) => {
  const {
    evaluateOverview,
    evaluateProgressByProcess,
    evaluateProgressByTeam,
  } = useVersionReportVersionRepository()
  const evaluate = useMemo(() => {
    if (!isAiAvailable()) {
      return undefined
    }
    if (!currentPage || !currentVersion) {
      return undefined
    }
    const targetUuids = currentPage.rows.map(r => r.targetUuid)
    switch (currentPage.pageType) {
      case 'PROGRESS_OVERVIEW':
        return async () => {
          // TODO(FE#4): AI 評価結果を rows に反映する処理を新 API で実装
          await evaluateOverview({
            snapshotUuid: currentVersion.snapshotUuid,
            leafUuids: targetUuids,
          })
        }

      case 'PROGRESS_REPORT_BY_PROCESS':
        return async () => {
          if (currentPage.config.type === 'PROGRESS_REPORT_BY_PROCESS') {
            // TODO(FE#4): AI 評価結果を rows に反映する処理を新 API で実装
            await evaluateProgressByProcess({
              snapshotUuid: currentVersion.snapshotUuid,
              projectPlanUuids: targetUuids,
            })
          }
        }

      case 'PROGRESS_REPORT_BY_TEAM':
        return async () => {
          if (currentPage.config.type === 'PROGRESS_REPORT_BY_TEAM') {
            // TODO(FE#4): AI 評価結果を rows に反映する処理を新 API で実装
            await evaluateProgressByTeam({
              snapshotUuid: currentVersion.snapshotUuid,
              teamUuids: targetUuids,
              rootUuid: currentPage.config.rootUuid,
            })
          }
        }
    }
  }, [
    currentPage,
    currentVersion,
    evaluateOverview,
    evaluateProgressByProcess,
    evaluateProgressByTeam,
  ])
  return { evaluate }
}
